import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Home, GraduationCap, Car, Landmark, Store, Building, ArrowRight, CheckCircle, Coins } from 'lucide-react';
import { mockData } from '../data/mock';
import { Button } from './ui/button';

const iconMap = {
  Home: Home,
  GraduationCap: GraduationCap,
  Car: Car,
  Landmark: Landmark,
  Store: Store,
  Building: Building,
  Coins: Coins
};

const LoanTypes = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-teal-100 text-teal-700 rounded-full text-sm font-medium mb-4">
            Loan Products
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Tailored Loan Solutions for Every Need
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Choose from our wide range of loan products with competitive rates and flexible terms
          </p>
        </div>

        {/* Loan Cards Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mockData.loanTypes.map((loan) => {
            const IconComponent = iconMap[loan.icon];
            return (
              <Card 
                key={loan.id}
                className="group hover:shadow-xl transition-all duration-300 border-2 border-gray-100 hover:border-cyan-200 bg-white"
              >
                <CardHeader>
                  <div className="flex items-center justify-between mb-4">
                    <div className="w-14 h-14 bg-gradient-to-br from-cyan-500 to-teal-600 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-md">
                      <IconComponent className="w-7 h-7 text-white" />
                    </div>
                    <span className="px-3 py-1 bg-green-100 text-green-700 text-xs font-semibold rounded-full">
                      Available
                    </span>
                  </div>
                  <CardTitle className="text-2xl text-gray-900 group-hover:text-cyan-600 transition-colors">
                    {loan.name}
                  </CardTitle>
                  <CardDescription className="text-gray-600">
                    {loan.description}
                  </CardDescription>
                </CardHeader>

                <CardContent className="space-y-4">
                  <div className="bg-cyan-50 p-4 rounded-lg border border-cyan-100">
                    <div className="text-sm text-cyan-700 font-medium mb-1">Interest Rate</div>
                    <div className="text-lg font-bold text-cyan-900">{loan.interestRate}</div>
                    {loan.disclaimer && (
                      <div className="text-xs text-gray-600 mt-2 italic">*{loan.disclaimer}</div>
                    )}
                  </div>

                  <div className="space-y-2">
                    {loan.features.map((feature) => (
                      <div key={`${loan.id}-${feature}`} className="flex items-start text-sm text-gray-700">
                        <CheckCircle className="w-4 h-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                        <span>{feature}</span>
                      </div>
                    ))}
                  </div>

                  <Link to="/contact" className="block">
                    <Button 
                      className="w-full bg-gradient-to-r from-cyan-500 to-teal-600 hover:from-cyan-600 hover:to-teal-700 text-white group/btn"
                    >
                      Apply Now
                      <ArrowRight className="ml-2 w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default LoanTypes;
